export const getBlogArticleParentPath = (resourceCategory) => {
    if (resourceCategory) {
        return resourceCategory.split('_').join('-');
    }
    return 'blog';
};
//# sourceMappingURL=blog-article-parent-path.js.map